<template>
  <div id="app">
    <div :class="['app-shell', { android: isAndroid, 'not-android': !isAndroid }]">
      <nav-bar class="app-navbar"
               v-show="(!$route.meta) || (!$route.meta.hideDefaultNavBar)">
      </nav-bar>

      <div class="app-content">
        <ProjectSettingsList v-if="$store.state.settings.project === 'list'" />
        <template v-else>
          <keep-alive>
            <router-view v-if="$route.meta && $route.meta.keepAlive"
                         :key="keepAliveKey"/>
          </keep-alive>
          <router-view v-if="(!$route.meta) || (!$route.meta.keepAlive)" />
        </template>

        <!-- Modals -->
        <b-modal v-if="$store.state.modals.photo"
                 v-model="$store.state.modals.photoShow"
                 id="modal-photo"
                 :title="$store.state.modals.photo.name"
                 size="lg">
          <img :src="$store.state.modals.photo.url" class="img-fluid"/>
        </b-modal>

        <b-modal v-if="$store.state.modals.orderSelect"
                 v-model="$store.state.modals.orderSelectShow"
                 id="modal-oder-select"
                 :title="$store.state.labels.form_select.configureOrder"
                 size="lg">
          <order-select/>
        </b-modal>
        <!-- dummy div for space at the buttom as for some reason, some device don't see it the last display elements. -->
        <div class="mt-5"></div>
      </div>
    </div>
  </div>
</template>

<script>
import navBar from './components/navbar.vue'
import orderSelect from './components/orderSelect.vue'
import ProjectSettingsList from './components/ProjectSettingsList.vue'
import { isPlatform } from "@ionic/vue";

// import cuid from 'cuid'

// https://github.com/AlwaysLoveme/capacitor-plugin-safe-area/tree/main
import { SafeArea } from 'capacitor-plugin-safe-area';

SafeArea.getSafeAreaInsets().then(({ insets }) => {
  console.log(insets);
});

SafeArea.getStatusBarHeight().then(({ statusBarHeight }) => {
  console.log(statusBarHeight, 'statusbarHeight');
});

await SafeArea.removeAllListeners();

// when safe-area changed
await SafeArea.addListener('safeAreaChanged', data => {
  const { insets } = data;
  for (const [key, value] of Object.entries(insets)) {
    document.documentElement.style.setProperty(
      `--safe-area-inset-${key}`,
      `${value}px`,
    );
  }
});

export default {
  name: 'App',
  components:{navBar,orderSelect,ProjectSettingsList},
  data() {
    return {

    }
  },
  computed:{
    isLogged(){return this.$store.state.isLogged},
    systemDoc(){return this.$store.state.systemDoc},
    isLocal(){return this.$store.getters['localDB/isOnlineMode']===false},
    keepAliveKey(){return this.$route.name + this.$store.state.localDB.keepAliveKey},
    isAndroid(){return isPlatform('android') && !isPlatform('mobileweb')},
  },
  watch:{
    // TODO: better handle when local change, now in each component... But could be here. But also, track when local data added or deleted, as is might change the current or alive view. Can we put a key in router-view, to be tested.
    // isLocal(){
    //   // database to use changed... reset myself.
    //   this.key = cuid()
    // },
  },
  methods:{

  }
}
</script>


<style>
:root {
  /* Fallbacks if plugin not yet set variables */
  --safe-area-inset-top: env(safe-area-inset-top, 0px);
  --safe-area-inset-bottom: env(safe-area-inset-bottom, 0px);
  --safe-area-inset-left: env(safe-area-inset-left, 0px);
  --safe-area-inset-right: env(safe-area-inset-right, 0px);
}

#app, .app-shell {
  height: 100vh;
  width: 100%;
  overflow: hidden; /* prevent body scroll; we scroll only .app-content */
  background: #fff;
}
.app-shell {
  display: flex;
  flex-direction: column;
}

/* Navbar */
.app-navbar,
.b-navbar {
  position: relative !important;  /* flow naturally, override any Bootstrap fixed-top if present */
  flex: 0 0 auto;
  z-index: 1030;
  padding-top: calc(0rem + var(--safe-area-inset-top)) !important;
  padding-bottom: 0.5rem;
  padding-left: calc(0rem + var(--safe-area-inset-left)) !important;
  padding-right: calc(0rem + var(--safe-area-inset-right)) !important;
  width: 100%;
}


/* Scrollable content area */
.app-content {
  position: relative;
  flex: 1 1 auto;
  height: auto;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-left: var(--safe-area-inset-left);
  padding-right: var(--safe-area-inset-right);
  padding-bottom: calc(var(--safe-area-inset-bottom) + 8px);
  box-sizing: border-box;
}
html {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: hidden;
}

.not-android {
  /* for navbar.*/
}
.android .app-content {
  /* removed fixed height calculations */
}
.android {
}
</style>
